import { __read, __spreadArray } from "tslib";
import { vec3 } from 'gl-matrix';
import { dirtifyToRoot } from '../services';
import { AABB } from '../shapes';
import { createVec3 } from '../utils';
export function updateAnchor(oldValue, newValue, object) {
  var bounds = object.getGeometryBounds();

  if (!AABB.isEmpty(bounds)) {
    var geometry = object.geometry;

    if (geometry && geometry.contentBounds) {
      var offset = vec3.multiply(vec3.create(), vec3.fromValues.apply(vec3, __spreadArray([], __read(bounds.halfExtents.map(function (n) {
        return n * 2;
      })), false)), vec3.subtract(vec3.create(), createVec3(newValue || vec3.create()), createVec3(oldValue || vec3.create())));
      geometry.contentBounds.update(vec3.subtract(geometry.contentBounds.center, geometry.contentBounds.center, offset), geometry.contentBounds.halfExtents);
      geometry.renderBounds.update(vec3.subtract(geometry.renderBounds.center, geometry.renderBounds.center, offset), geometry.renderBounds.halfExtents);
      dirtifyToRoot(object);
    }
  }
}